/**
 * Generated by orval 🍺
 * Do not edit manually.
 * Impero Org API
 * The Impero Backend's API for organizations, i.e. orgname.impero.com.
 */
import { useMutation, useQuery, useSuspenseQuery } from "@tanstack/react-query";
import type {
    DataTag,
    DefinedInitialDataOptions,
    DefinedUseQueryResult,
    MutationFunction,
    QueryClient,
    QueryFunction,
    QueryKey,
    UndefinedInitialDataOptions,
    UseMutationOptions,
    UseMutationResult,
    UseQueryOptions,
    UseQueryResult,
    UseSuspenseQueryOptions,
    UseSuspenseQueryResult,
} from "@tanstack/react-query";

import axios from "axios";
import type { AxiosError, AxiosRequestConfig, AxiosResponse } from "axios";

import type {
    ControlEntityConflict,
    CreateEntity,
    EntitiesAccessRightsUpdateResult,
    EntityCountDto,
    EntityId,
    EntityOverviewListDto,
    EntityView,
    EntityViewDto,
    GetEntitiesParams,
    UpdatableEntitiesAccessRights,
    UpdatableEntity,
} from "../model";

type AwaitedInput<T> = PromiseLike<T> | T;

type Awaited<O> = O extends AwaitedInput<infer T> ? T : never;

const withQueryKey = <T extends object, K>(
    query: T,
    queryKey: K
): T & { queryKey: K } => {
    const result = { queryKey } as T & { queryKey: K };
    for (const key of Object.keys(query)) {
        // The explicit queryKey always wins, matching the previous
        // `{ ...query, queryKey }` spread where it was set last.
        if (key === "queryKey") continue;
        Object.defineProperty(result, key, {
            enumerable: true,
            configurable: true,
            get: () => (query as Record<string, unknown>)[key],
        });
    }
    return result;
};

export const getEntitiesEntityId = (
    entityId: EntityId,
    options?: AxiosRequestConfig
): Promise<AxiosResponse<EntityViewDto>> => {
    return axios.get(`/api/entities/${entityId}`, options);
};

export const getGetEntitiesEntityIdQueryKey = (entityId: EntityId) => {
    return [`/api/entities/${entityId}`] as const;
};

export const getGetEntitiesEntityIdQueryOptions = <
    TData = Awaited<ReturnType<typeof getEntitiesEntityId>>,
    TError = AxiosError<unknown>,
>(
    entityId: EntityId,
    options?: {
        query?: Partial<
            UseQueryOptions<
                Awaited<ReturnType<typeof getEntitiesEntityId>>,
                TError,
                TData
            >
        >;
        axios?: AxiosRequestConfig;
    }
) => {
    const { query: queryOptions, axios: axiosOptions } = options ?? {};

    const queryKey =
        queryOptions?.queryKey ?? getGetEntitiesEntityIdQueryKey(entityId);

    const queryFn: QueryFunction<
        Awaited<ReturnType<typeof getEntitiesEntityId>>
    > = ({ signal }) =>
        getEntitiesEntityId(entityId, { signal, ...axiosOptions });

    return {
        queryKey,
        queryFn,
        enabled: entityId !== null && entityId !== undefined,
        ...queryOptions,
    } as UseQueryOptions<
        Awaited<ReturnType<typeof getEntitiesEntityId>>,
        TError,
        TData
    > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetEntitiesEntityIdQueryResult = NonNullable<
    Awaited<ReturnType<typeof getEntitiesEntityId>>
>;
export type GetEntitiesEntityIdQueryError = AxiosError<unknown>;

export function useGetEntitiesEntityId<
    TData = Awaited<ReturnType<typeof getEntitiesEntityId>>,
    TError = AxiosError<unknown>,
>(
    entityId: EntityId,
    options: {
        query: Partial<
            UseQueryOptions<
                Awaited<ReturnType<typeof getEntitiesEntityId>>,
                TError,
                TData
            >
        > &
            Pick<
                DefinedInitialDataOptions<
                    Awaited<ReturnType<typeof getEntitiesEntityId>>,
                    TError,
                    Awaited<ReturnType<typeof getEntitiesEntityId>>
                >,
                "initialData"
            >;
        axios?: AxiosRequestConfig;
    },
    queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetEntitiesEntityId<
    TData = Awaited<ReturnType<typeof getEntitiesEntityId>>,
    TError = AxiosError<unknown>,
>(
    entityId: EntityId,
    options?: {
        query?: Partial<
            UseQueryOptions<
                Awaited<ReturnType<typeof getEntitiesEntityId>>,
                TError,
                TData
            >
        > &
            Pick<
                UndefinedInitialDataOptions<
                    Awaited<ReturnType<typeof getEntitiesEntityId>>,
                    TError,
                    Awaited<ReturnType<typeof getEntitiesEntityId>>
                >,
                "initialData"
            >;
        axios?: AxiosRequestConfig;
    },
    queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetEntitiesEntityId<
    TData = Awaited<ReturnType<typeof getEntitiesEntityId>>,
    TError = AxiosError<unknown>,
>(
    entityId: EntityId,
    options?: {
        query?: Partial<
            UseQueryOptions<
                Awaited<ReturnType<typeof getEntitiesEntityId>>,
                TError,
                TData
            >
        >;
        axios?: AxiosRequestConfig;
    },
    queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
};

export function useGetEntitiesEntityId<
    TData = Awaited<ReturnType<typeof getEntitiesEntityId>>,
    TError = AxiosError<unknown>,
>(
    entityId: EntityId,
    options?: {
        query?: Partial<
            UseQueryOptions<
                Awaited<ReturnType<typeof getEntitiesEntityId>>,
                TError,
                TData
            >
        >;
        axios?: AxiosRequestConfig;
    },
    queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
} {
    const queryOptions = getGetEntitiesEntityIdQueryOptions(entityId, options);

    const query = useQuery(queryOptions, queryClient) as UseQueryResult<
        TData,
        TError
    > & { queryKey: DataTag<QueryKey, TData, TError> };

    return withQueryKey(query, queryOptions.queryKey);
}

export const getGetEntitiesEntityIdSuspenseQueryOptions = <
    TData = Awaited<ReturnType<typeof getEntitiesEntityId>>,
    TError = AxiosError<unknown>,
>(
    entityId: EntityId,
    options?: {
        query?: Partial<
            UseSuspenseQueryOptions<
                Awaited<ReturnType<typeof getEntitiesEntityId>>,
                TError,
                TData
            >
        >;
        axios?: AxiosRequestConfig;
    }
) => {
    const { query: queryOptions, axios: axiosOptions } = options ?? {};

    const queryKey =
        queryOptions?.queryKey ?? getGetEntitiesEntityIdQueryKey(entityId);

    const queryFn: QueryFunction<
        Awaited<ReturnType<typeof getEntitiesEntityId>>
    > = ({ signal }) =>
        getEntitiesEntityId(entityId, { signal, ...axiosOptions });

    return { queryKey, queryFn, ...queryOptions } as UseSuspenseQueryOptions<
        Awaited<ReturnType<typeof getEntitiesEntityId>>,
        TError,
        TData
    > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetEntitiesEntityIdSuspenseQueryResult = NonNullable<
    Awaited<ReturnType<typeof getEntitiesEntityId>>
>;
export type GetEntitiesEntityIdSuspenseQueryError = AxiosError<unknown>;

export function useGetEntitiesEntityIdSuspense<
    TData = Awaited<ReturnType<typeof getEntitiesEntityId>>,
    TError = AxiosError<unknown>,
>(
    entityId: EntityId,
    options: {
        query: Partial<
            UseSuspenseQueryOptions<
                Awaited<ReturnType<typeof getEntitiesEntityId>>,
                TError,
                TData
            >
        >;
        axios?: AxiosRequestConfig;
    },
    queryClient?: QueryClient
): UseSuspenseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetEntitiesEntityIdSuspense<
    TData = Awaited<ReturnType<typeof getEntitiesEntityId>>,
    TError = AxiosError<unknown>,
>(
    entityId: EntityId,
    options?: {
        query?: Partial<
            UseSuspenseQueryOptions<
                Awaited<ReturnType<typeof getEntitiesEntityId>>,
                TError,
                TData
            >
        >;
        axios?: AxiosRequestConfig;
    },
    queryClient?: QueryClient
): UseSuspenseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetEntitiesEntityIdSuspense<
    TData = Awaited<ReturnType<typeof getEntitiesEntityId>>,
    TError = AxiosError<unknown>,
>(
    entityId: EntityId,
    options?: {
        query?: Partial<
            UseSuspenseQueryOptions<
                Awaited<ReturnType<typeof getEntitiesEntityId>>,
                TError,
                TData
            >
        >;
        axios?: AxiosRequestConfig;
    },
    queryClient?: QueryClient
): UseSuspenseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
};

export function useGetEntitiesEntityIdSuspense<
    TData = Awaited<ReturnType<typeof getEntitiesEntityId>>,
    TError = AxiosError<unknown>,
>(
    entityId: EntityId,
    options?: {
        query?: Partial<
            UseSuspenseQueryOptions<
                Awaited<ReturnType<typeof getEntitiesEntityId>>,
                TError,
                TData
            >
        >;
        axios?: AxiosRequestConfig;
    },
    queryClient?: QueryClient
): UseSuspenseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
} {
    const queryOptions = getGetEntitiesEntityIdSuspenseQueryOptions(
        entityId,
        options
    );

    const query = useSuspenseQuery(
        queryOptions,
        queryClient
    ) as UseSuspenseQueryResult<TData, TError> & {
        queryKey: DataTag<QueryKey, TData, TError>;
    };

    return withQueryKey(query, queryOptions.queryKey);
}

export const deleteEntitiesEntityId = (
    entityId: EntityId,
    options?: AxiosRequestConfig
): Promise<AxiosResponse<void>> => {
    return axios.delete(`/api/entities/${entityId}`, options);
};

export const getDeleteEntitiesEntityIdMutationOptions = <
    TError = AxiosError<ControlEntityConflict>,
    TContext = unknown,
>(options?: {
    mutation?: UseMutationOptions<
        Awaited<ReturnType<typeof deleteEntitiesEntityId>>,
        TError,
        { entityId: EntityId },
        TContext
    >;
    axios?: AxiosRequestConfig;
}): UseMutationOptions<
    Awaited<ReturnType<typeof deleteEntitiesEntityId>>,
    TError,
    { entityId: EntityId },
    TContext
> => {
    const mutationKey = ["deleteEntitiesEntityId"];
    const { mutation: mutationOptions, axios: axiosOptions } = options
        ? options.mutation &&
          "mutationKey" in options.mutation &&
          options.mutation.mutationKey
            ? options
            : { ...options, mutation: { ...options.mutation, mutationKey } }
        : { mutation: { mutationKey }, axios: undefined };

    const mutationFn: MutationFunction<
        Awaited<ReturnType<typeof deleteEntitiesEntityId>>,
        { entityId: EntityId }
    > = (props) => {
        const { entityId } = props ?? {};

        return deleteEntitiesEntityId(entityId, axiosOptions);
    };

    return { mutationFn, ...mutationOptions };
};

export type DeleteEntitiesEntityIdMutationResult = NonNullable<
    Awaited<ReturnType<typeof deleteEntitiesEntityId>>
>;

export type DeleteEntitiesEntityIdMutationError =
    AxiosError<ControlEntityConflict>;

export const useDeleteEntitiesEntityId = <
    TError = AxiosError<ControlEntityConflict>,
    TContext = unknown,
>(
    options?: {
        mutation?: UseMutationOptions<
            Awaited<ReturnType<typeof deleteEntitiesEntityId>>,
            TError,
            { entityId: EntityId },
            TContext
        >;
        axios?: AxiosRequestConfig;
    },
    queryClient?: QueryClient
): UseMutationResult<
    Awaited<ReturnType<typeof deleteEntitiesEntityId>>,
    TError,
    { entityId: EntityId },
    TContext
> => {
    return useMutation(
        getDeleteEntitiesEntityIdMutationOptions(options),
        queryClient
    );
};
export const patchEntitiesEntityId = (
    entityId: EntityId,
    updatableEntity: UpdatableEntity,
    options?: AxiosRequestConfig
): Promise<AxiosResponse<EntityViewDto>> => {
    return axios.patch(`/api/entities/${entityId}`, updatableEntity, options);
};

export const getPatchEntitiesEntityIdMutationOptions = <
    TError = AxiosError<unknown>,
    TContext = unknown,
>(options?: {
    mutation?: UseMutationOptions<
        Awaited<ReturnType<typeof patchEntitiesEntityId>>,
        TError,
        { entityId: EntityId; data: UpdatableEntity },
        TContext
    >;
    axios?: AxiosRequestConfig;
}): UseMutationOptions<
    Awaited<ReturnType<typeof patchEntitiesEntityId>>,
    TError,
    { entityId: EntityId; data: UpdatableEntity },
    TContext
> => {
    const mutationKey = ["patchEntitiesEntityId"];
    const { mutation: mutationOptions, axios: axiosOptions } = options
        ? options.mutation &&
          "mutationKey" in options.mutation &&
          options.mutation.mutationKey
            ? options
            : { ...options, mutation: { ...options.mutation, mutationKey } }
        : { mutation: { mutationKey }, axios: undefined };

    const mutationFn: MutationFunction<
        Awaited<ReturnType<typeof patchEntitiesEntityId>>,
        { entityId: EntityId; data: UpdatableEntity }
    > = (props) => {
        const { entityId, data } = props ?? {};

        return patchEntitiesEntityId(entityId, data, axiosOptions);
    };

    return { mutationFn, ...mutationOptions };
};

export type PatchEntitiesEntityIdMutationResult = NonNullable<
    Awaited<ReturnType<typeof patchEntitiesEntityId>>
>;
export type PatchEntitiesEntityIdMutationBody = UpdatableEntity;
export type PatchEntitiesEntityIdMutationError = AxiosError<unknown>;

export const usePatchEntitiesEntityId = <
    TError = AxiosError<unknown>,
    TContext = unknown,
>(
    options?: {
        mutation?: UseMutationOptions<
            Awaited<ReturnType<typeof patchEntitiesEntityId>>,
            TError,
            { entityId: EntityId; data: UpdatableEntity },
            TContext
        >;
        axios?: AxiosRequestConfig;
    },
    queryClient?: QueryClient
): UseMutationResult<
    Awaited<ReturnType<typeof patchEntitiesEntityId>>,
    TError,
    { entityId: EntityId; data: UpdatableEntity },
    TContext
> => {
    return useMutation(
        getPatchEntitiesEntityIdMutationOptions(options),
        queryClient
    );
};
export const entityCount = (
    entityId: EntityId,
    options?: AxiosRequestConfig
): Promise<AxiosResponse<EntityCountDto>> => {
    return axios.get(`/api/entities/${entityId}/count`, options);
};

export const getEntityCountQueryKey = (entityId: EntityId) => {
    return [`/api/entities/${entityId}/count`] as const;
};

export const getEntityCountQueryOptions = <
    TData = Awaited<ReturnType<typeof entityCount>>,
    TError = AxiosError<unknown>,
>(
    entityId: EntityId,
    options?: {
        query?: Partial<
            UseQueryOptions<
                Awaited<ReturnType<typeof entityCount>>,
                TError,
                TData
            >
        >;
        axios?: AxiosRequestConfig;
    }
) => {
    const { query: queryOptions, axios: axiosOptions } = options ?? {};

    const queryKey = queryOptions?.queryKey ?? getEntityCountQueryKey(entityId);

    const queryFn: QueryFunction<Awaited<ReturnType<typeof entityCount>>> = ({
        signal,
    }) => entityCount(entityId, { signal, ...axiosOptions });

    return {
        queryKey,
        queryFn,
        enabled: entityId !== null && entityId !== undefined,
        ...queryOptions,
    } as UseQueryOptions<
        Awaited<ReturnType<typeof entityCount>>,
        TError,
        TData
    > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type EntityCountQueryResult = NonNullable<
    Awaited<ReturnType<typeof entityCount>>
>;
export type EntityCountQueryError = AxiosError<unknown>;

export function useEntityCount<
    TData = Awaited<ReturnType<typeof entityCount>>,
    TError = AxiosError<unknown>,
>(
    entityId: EntityId,
    options: {
        query: Partial<
            UseQueryOptions<
                Awaited<ReturnType<typeof entityCount>>,
                TError,
                TData
            >
        > &
            Pick<
                DefinedInitialDataOptions<
                    Awaited<ReturnType<typeof entityCount>>,
                    TError,
                    Awaited<ReturnType<typeof entityCount>>
                >,
                "initialData"
            >;
        axios?: AxiosRequestConfig;
    },
    queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
};
export function useEntityCount<
    TData = Awaited<ReturnType<typeof entityCount>>,
    TError = AxiosError<unknown>,
>(
    entityId: EntityId,
    options?: {
        query?: Partial<
            UseQueryOptions<
                Awaited<ReturnType<typeof entityCount>>,
                TError,
                TData
            >
        > &
            Pick<
                UndefinedInitialDataOptions<
                    Awaited<ReturnType<typeof entityCount>>,
                    TError,
                    Awaited<ReturnType<typeof entityCount>>
                >,
                "initialData"
            >;
        axios?: AxiosRequestConfig;
    },
    queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
};
export function useEntityCount<
    TData = Awaited<ReturnType<typeof entityCount>>,
    TError = AxiosError<unknown>,
>(
    entityId: EntityId,
    options?: {
        query?: Partial<
            UseQueryOptions<
                Awaited<ReturnType<typeof entityCount>>,
                TError,
                TData
            >
        >;
        axios?: AxiosRequestConfig;
    },
    queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
};

export function useEntityCount<
    TData = Awaited<ReturnType<typeof entityCount>>,
    TError = AxiosError<unknown>,
>(
    entityId: EntityId,
    options?: {
        query?: Partial<
            UseQueryOptions<
                Awaited<ReturnType<typeof entityCount>>,
                TError,
                TData
            >
        >;
        axios?: AxiosRequestConfig;
    },
    queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
} {
    const queryOptions = getEntityCountQueryOptions(entityId, options);

    const query = useQuery(queryOptions, queryClient) as UseQueryResult<
        TData,
        TError
    > & { queryKey: DataTag<QueryKey, TData, TError> };

    return withQueryKey(query, queryOptions.queryKey);
}

export const getEntityCountSuspenseQueryOptions = <
    TData = Awaited<ReturnType<typeof entityCount>>,
    TError = AxiosError<unknown>,
>(
    entityId: EntityId,
    options?: {
        query?: Partial<
            UseSuspenseQueryOptions<
                Awaited<ReturnType<typeof entityCount>>,
                TError,
                TData
            >
        >;
        axios?: AxiosRequestConfig;
    }
) => {
    const { query: queryOptions, axios: axiosOptions } = options ?? {};

    const queryKey = queryOptions?.queryKey ?? getEntityCountQueryKey(entityId);

    const queryFn: QueryFunction<Awaited<ReturnType<typeof entityCount>>> = ({
        signal,
    }) => entityCount(entityId, { signal, ...axiosOptions });

    return { queryKey, queryFn, ...queryOptions } as UseSuspenseQueryOptions<
        Awaited<ReturnType<typeof entityCount>>,
        TError,
        TData
    > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type EntityCountSuspenseQueryResult = NonNullable<
    Awaited<ReturnType<typeof entityCount>>
>;
export type EntityCountSuspenseQueryError = AxiosError<unknown>;

export function useEntityCountSuspense<
    TData = Awaited<ReturnType<typeof entityCount>>,
    TError = AxiosError<unknown>,
>(
    entityId: EntityId,
    options: {
        query: Partial<
            UseSuspenseQueryOptions<
                Awaited<ReturnType<typeof entityCount>>,
                TError,
                TData
            >
        >;
        axios?: AxiosRequestConfig;
    },
    queryClient?: QueryClient
): UseSuspenseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
};
export function useEntityCountSuspense<
    TData = Awaited<ReturnType<typeof entityCount>>,
    TError = AxiosError<unknown>,
>(
    entityId: EntityId,
    options?: {
        query?: Partial<
            UseSuspenseQueryOptions<
                Awaited<ReturnType<typeof entityCount>>,
                TError,
                TData
            >
        >;
        axios?: AxiosRequestConfig;
    },
    queryClient?: QueryClient
): UseSuspenseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
};
export function useEntityCountSuspense<
    TData = Awaited<ReturnType<typeof entityCount>>,
    TError = AxiosError<unknown>,
>(
    entityId: EntityId,
    options?: {
        query?: Partial<
            UseSuspenseQueryOptions<
                Awaited<ReturnType<typeof entityCount>>,
                TError,
                TData
            >
        >;
        axios?: AxiosRequestConfig;
    },
    queryClient?: QueryClient
): UseSuspenseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
};

export function useEntityCountSuspense<
    TData = Awaited<ReturnType<typeof entityCount>>,
    TError = AxiosError<unknown>,
>(
    entityId: EntityId,
    options?: {
        query?: Partial<
            UseSuspenseQueryOptions<
                Awaited<ReturnType<typeof entityCount>>,
                TError,
                TData
            >
        >;
        axios?: AxiosRequestConfig;
    },
    queryClient?: QueryClient
): UseSuspenseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
} {
    const queryOptions = getEntityCountSuspenseQueryOptions(entityId, options);

    const query = useSuspenseQuery(
        queryOptions,
        queryClient
    ) as UseSuspenseQueryResult<TData, TError> & {
        queryKey: DataTag<QueryKey, TData, TError>;
    };

    return withQueryKey(query, queryOptions.queryKey);
}

export const getEntities = (
    params?: GetEntitiesParams,
    options?: AxiosRequestConfig
): Promise<AxiosResponse<EntityOverviewListDto>> => {
    return axios.get(`/api/entities`, {
        paramsSerializer: { indexes: null },
        ...options,
        params: { ...params, ...options?.params },
    });
};

export const getGetEntitiesQueryKey = (params?: GetEntitiesParams) => {
    return [`/api/entities`, ...(params ? [params] : [])] as const;
};

export const getGetEntitiesQueryOptions = <
    TData = Awaited<ReturnType<typeof getEntities>>,
    TError = AxiosError<unknown>,
>(
    params?: GetEntitiesParams,
    options?: {
        query?: Partial<
            UseQueryOptions<
                Awaited<ReturnType<typeof getEntities>>,
                TError,
                TData
            >
        >;
        axios?: AxiosRequestConfig;
    }
) => {
    const { query: queryOptions, axios: axiosOptions } = options ?? {};

    const queryKey = queryOptions?.queryKey ?? getGetEntitiesQueryKey(params);

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getEntities>>> = ({
        signal,
    }) => getEntities(params, { signal, ...axiosOptions });

    return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
        Awaited<ReturnType<typeof getEntities>>,
        TError,
        TData
    > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetEntitiesQueryResult = NonNullable<
    Awaited<ReturnType<typeof getEntities>>
>;
export type GetEntitiesQueryError = AxiosError<unknown>;

export function useGetEntities<
    TData = Awaited<ReturnType<typeof getEntities>>,
    TError = AxiosError<unknown>,
>(
    params: undefined | GetEntitiesParams,
    options: {
        query: Partial<
            UseQueryOptions<
                Awaited<ReturnType<typeof getEntities>>,
                TError,
                TData
            >
        > &
            Pick<
                DefinedInitialDataOptions<
                    Awaited<ReturnType<typeof getEntities>>,
                    TError,
                    Awaited<ReturnType<typeof getEntities>>
                >,
                "initialData"
            >;
        axios?: AxiosRequestConfig;
    },
    queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetEntities<
    TData = Awaited<ReturnType<typeof getEntities>>,
    TError = AxiosError<unknown>,
>(
    params?: GetEntitiesParams,
    options?: {
        query?: Partial<
            UseQueryOptions<
                Awaited<ReturnType<typeof getEntities>>,
                TError,
                TData
            >
        > &
            Pick<
                UndefinedInitialDataOptions<
                    Awaited<ReturnType<typeof getEntities>>,
                    TError,
                    Awaited<ReturnType<typeof getEntities>>
                >,
                "initialData"
            >;
        axios?: AxiosRequestConfig;
    },
    queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetEntities<
    TData = Awaited<ReturnType<typeof getEntities>>,
    TError = AxiosError<unknown>,
>(
    params?: GetEntitiesParams,
    options?: {
        query?: Partial<
            UseQueryOptions<
                Awaited<ReturnType<typeof getEntities>>,
                TError,
                TData
            >
        >;
        axios?: AxiosRequestConfig;
    },
    queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
};

export function useGetEntities<
    TData = Awaited<ReturnType<typeof getEntities>>,
    TError = AxiosError<unknown>,
>(
    params?: GetEntitiesParams,
    options?: {
        query?: Partial<
            UseQueryOptions<
                Awaited<ReturnType<typeof getEntities>>,
                TError,
                TData
            >
        >;
        axios?: AxiosRequestConfig;
    },
    queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
} {
    const queryOptions = getGetEntitiesQueryOptions(params, options);

    const query = useQuery(queryOptions, queryClient) as UseQueryResult<
        TData,
        TError
    > & { queryKey: DataTag<QueryKey, TData, TError> };

    return withQueryKey(query, queryOptions.queryKey);
}

export const getGetEntitiesSuspenseQueryOptions = <
    TData = Awaited<ReturnType<typeof getEntities>>,
    TError = AxiosError<unknown>,
>(
    params?: GetEntitiesParams,
    options?: {
        query?: Partial<
            UseSuspenseQueryOptions<
                Awaited<ReturnType<typeof getEntities>>,
                TError,
                TData
            >
        >;
        axios?: AxiosRequestConfig;
    }
) => {
    const { query: queryOptions, axios: axiosOptions } = options ?? {};

    const queryKey = queryOptions?.queryKey ?? getGetEntitiesQueryKey(params);

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getEntities>>> = ({
        signal,
    }) => getEntities(params, { signal, ...axiosOptions });

    return { queryKey, queryFn, ...queryOptions } as UseSuspenseQueryOptions<
        Awaited<ReturnType<typeof getEntities>>,
        TError,
        TData
    > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetEntitiesSuspenseQueryResult = NonNullable<
    Awaited<ReturnType<typeof getEntities>>
>;
export type GetEntitiesSuspenseQueryError = AxiosError<unknown>;

export function useGetEntitiesSuspense<
    TData = Awaited<ReturnType<typeof getEntities>>,
    TError = AxiosError<unknown>,
>(
    params: undefined | GetEntitiesParams,
    options: {
        query: Partial<
            UseSuspenseQueryOptions<
                Awaited<ReturnType<typeof getEntities>>,
                TError,
                TData
            >
        >;
        axios?: AxiosRequestConfig;
    },
    queryClient?: QueryClient
): UseSuspenseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetEntitiesSuspense<
    TData = Awaited<ReturnType<typeof getEntities>>,
    TError = AxiosError<unknown>,
>(
    params?: GetEntitiesParams,
    options?: {
        query?: Partial<
            UseSuspenseQueryOptions<
                Awaited<ReturnType<typeof getEntities>>,
                TError,
                TData
            >
        >;
        axios?: AxiosRequestConfig;
    },
    queryClient?: QueryClient
): UseSuspenseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetEntitiesSuspense<
    TData = Awaited<ReturnType<typeof getEntities>>,
    TError = AxiosError<unknown>,
>(
    params?: GetEntitiesParams,
    options?: {
        query?: Partial<
            UseSuspenseQueryOptions<
                Awaited<ReturnType<typeof getEntities>>,
                TError,
                TData
            >
        >;
        axios?: AxiosRequestConfig;
    },
    queryClient?: QueryClient
): UseSuspenseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
};

export function useGetEntitiesSuspense<
    TData = Awaited<ReturnType<typeof getEntities>>,
    TError = AxiosError<unknown>,
>(
    params?: GetEntitiesParams,
    options?: {
        query?: Partial<
            UseSuspenseQueryOptions<
                Awaited<ReturnType<typeof getEntities>>,
                TError,
                TData
            >
        >;
        axios?: AxiosRequestConfig;
    },
    queryClient?: QueryClient
): UseSuspenseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
} {
    const queryOptions = getGetEntitiesSuspenseQueryOptions(params, options);

    const query = useSuspenseQuery(
        queryOptions,
        queryClient
    ) as UseSuspenseQueryResult<TData, TError> & {
        queryKey: DataTag<QueryKey, TData, TError>;
    };

    return withQueryKey(query, queryOptions.queryKey);
}

export const postEntities = (
    createEntity: CreateEntity,
    options?: AxiosRequestConfig
): Promise<AxiosResponse<EntityView>> => {
    return axios.post(`/api/entities`, createEntity, options);
};

export const getPostEntitiesMutationOptions = <
    TError = AxiosError<ControlEntityConflict>,
    TContext = unknown,
>(options?: {
    mutation?: UseMutationOptions<
        Awaited<ReturnType<typeof postEntities>>,
        TError,
        { data: CreateEntity },
        TContext
    >;
    axios?: AxiosRequestConfig;
}): UseMutationOptions<
    Awaited<ReturnType<typeof postEntities>>,
    TError,
    { data: CreateEntity },
    TContext
> => {
    const mutationKey = ["postEntities"];
    const { mutation: mutationOptions, axios: axiosOptions } = options
        ? options.mutation &&
          "mutationKey" in options.mutation &&
          options.mutation.mutationKey
            ? options
            : { ...options, mutation: { ...options.mutation, mutationKey } }
        : { mutation: { mutationKey }, axios: undefined };

    const mutationFn: MutationFunction<
        Awaited<ReturnType<typeof postEntities>>,
        { data: CreateEntity }
    > = (props) => {
        const { data } = props ?? {};

        return postEntities(data, axiosOptions);
    };

    return { mutationFn, ...mutationOptions };
};

export type PostEntitiesMutationResult = NonNullable<
    Awaited<ReturnType<typeof postEntities>>
>;
export type PostEntitiesMutationBody = CreateEntity;
export type PostEntitiesMutationError = AxiosError<ControlEntityConflict>;

export const usePostEntities = <
    TError = AxiosError<ControlEntityConflict>,
    TContext = unknown,
>(
    options?: {
        mutation?: UseMutationOptions<
            Awaited<ReturnType<typeof postEntities>>,
            TError,
            { data: CreateEntity },
            TContext
        >;
        axios?: AxiosRequestConfig;
    },
    queryClient?: QueryClient
): UseMutationResult<
    Awaited<ReturnType<typeof postEntities>>,
    TError,
    { data: CreateEntity },
    TContext
> => {
    return useMutation(getPostEntitiesMutationOptions(options), queryClient);
};
export const patchEntities = (
    updatableEntitiesAccessRights: UpdatableEntitiesAccessRights,
    options?: AxiosRequestConfig
): Promise<AxiosResponse<EntitiesAccessRightsUpdateResult>> => {
    return axios.patch(`/api/entities`, updatableEntitiesAccessRights, options);
};

export const getPatchEntitiesMutationOptions = <
    TError = AxiosError<null>,
    TContext = unknown,
>(options?: {
    mutation?: UseMutationOptions<
        Awaited<ReturnType<typeof patchEntities>>,
        TError,
        { data: UpdatableEntitiesAccessRights },
        TContext
    >;
    axios?: AxiosRequestConfig;
}): UseMutationOptions<
    Awaited<ReturnType<typeof patchEntities>>,
    TError,
    { data: UpdatableEntitiesAccessRights },
    TContext
> => {
    const mutationKey = ["patchEntities"];
    const { mutation: mutationOptions, axios: axiosOptions } = options
        ? options.mutation &&
          "mutationKey" in options.mutation &&
          options.mutation.mutationKey
            ? options
            : { ...options, mutation: { ...options.mutation, mutationKey } }
        : { mutation: { mutationKey }, axios: undefined };

    const mutationFn: MutationFunction<
        Awaited<ReturnType<typeof patchEntities>>,
        { data: UpdatableEntitiesAccessRights }
    > = (props) => {
        const { data } = props ?? {};

        return patchEntities(data, axiosOptions);
    };

    return { mutationFn, ...mutationOptions };
};

export type PatchEntitiesMutationResult = NonNullable<
    Awaited<ReturnType<typeof patchEntities>>
>;
export type PatchEntitiesMutationBody = UpdatableEntitiesAccessRights;
export type PatchEntitiesMutationError = AxiosError<null>;

export const usePatchEntities = <TError = AxiosError<null>, TContext = unknown>(
    options?: {
        mutation?: UseMutationOptions<
            Awaited<ReturnType<typeof patchEntities>>,
            TError,
            { data: UpdatableEntitiesAccessRights },
            TContext
        >;
        axios?: AxiosRequestConfig;
    },
    queryClient?: QueryClient
): UseMutationResult<
    Awaited<ReturnType<typeof patchEntities>>,
    TError,
    { data: UpdatableEntitiesAccessRights },
    TContext
> => {
    return useMutation(getPatchEntitiesMutationOptions(options), queryClient);
};
